import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { XrefApiWebhookInfo } from 'src/app/services/xref-api/xref-api.service';

@Component({
  selector: 'app-xref-api-webhook-modal',
  templateUrl: './xref-api-webhook-modal.component.pug',
  styleUrls: ['./xref-api-webhook-modal.component.scss'],
  standalone: false,
})
export class XrefApiWebhookModalComponent implements OnInit {
  webhook: XrefApiWebhookInfo | null = null;
  urlInput = '';
  copied = false;
  docsUrl = 'https://docs.xref.com/webhooks.html';
  copyIconSrc = 'https://assets.xref.com/omni/xref_lib/copy-icon.svg';

  @Output() saveClick = new EventEmitter<string>();
  @Output() deleteClick = new EventEmitter<void>();

  private static readonly HTTPS_URL = /^https:\/\/[^\s]+$/i;

  constructor(public bsModalRef: BsModalRef) {}

  ngOnInit(): void {
    this.urlInput = this.webhook?.url ?? '';
  }

  get canSave(): boolean {
    return !this.webhook && this.isValidWebhookUrl(this.urlInput);
  }

  get copyButtonLabel(): string {
    return this.copied ? $localize`Copied` : $localize`Copy`;
  }

  isValidWebhookUrl(url: string): boolean {
    const trimmed = (url || '').trim();
    if (!trimmed) {
      return false;
    }
    return XrefApiWebhookModalComponent.HTTPS_URL.test(trimmed);
  }

  save(): void {
    const url = (this.urlInput || '').trim();
    if (!this.isValidWebhookUrl(url)) {
      return;
    }
    this.saveClick.emit(url);
  }

  delete(): void {
    this.deleteClick.emit();
  }

  async copySecret(): Promise<void> {
    const secret = this.webhook?.secret;
    const clip = navigator.clipboard;
    if (!secret || !clip || typeof clip.writeText !== 'function') {
      return;
    }
    await clip.writeText(secret);
    this.copied = true;
  }

  close(): void {
    this.bsModalRef.hide();
  }

  openDocs(): void {
    window.open(this.docsUrl, '_blank', 'noopener');
  }
}
